import React from "react";

const Footer = ({ toggled }) => {
  return (
    <footer className={`footer bg-light text-dark ${toggled ? "toggled" : ""}`}>
      © {new Date().getFullYear()} - Fakultas Kedokteran Trisakti. All rights
      reserved.
    </footer>
  );
};

export default Footer;
